var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoal1 = function SvgGoal1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    viewBox: "0 0 810 810",
    height: 1080
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 40.5h729v729h-729Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 40.5h679.5V717H90Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec3655",
    d: "M769.535 405c0 201.32-163.215 364.535-364.535 364.535C203.68 769.535 40.465 606.32 40.465 405 40.465 203.645 203.68 40.465 405 40.465c201.32 0 364.535 163.18 364.535 364.535"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M669.043 405c0 145.836-118.207 264.043-264.043 264.043S140.957 550.836 140.957 405 259.164 140.957 405 140.957 669.043 259.164 669.043 405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec3655",
    d: "M577.402 405c0 95.242-77.16 172.402-172.402 172.402-95.203 0-172.402-77.16-172.402-172.402 0-95.203 77.199-172.402 172.402-172.402 95.242 0 172.402 77.199 172.402 172.402"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M493.223 405c0 48.723-39.5 88.223-88.223 88.223s-88.223-39.5-88.223-88.223 39.5-88.223 88.223-88.223 88.223 39.5 88.223 88.223"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3abdc4",
    d: "M673.453 133.133 549.7 256.922l65.11 25.351 124.78-124.742-66.136-24.398"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3abdc4",
    d: "M673.453 133.133 549.7 256.922l-25.39-65.11 124.78-124.785 24.364 66.106"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m399.339 362.009 2.648 42.59 42.586 2.68",
    stroke: "#51558f",
    strokeWidth: 22.0464,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m694.319 112.298-292.332 292.3",
    stroke: "#51558f",
    strokeWidth: 22.0464,
    strokeMiterlimit: 10
  }))));
};
export default SvgGoal1;